var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart-skeleton-loader-container",class:{horizontal: _vm.horizontal}},_vm._l((_vm.barsCount),function(bar){return _c('div',{key:bar,staticClass:"bar-chart",style:({
      height: `${Math.random() * 101}%`,
      width: `${_vm.barWidth}px`,
    })})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }